import { koComponent } from '../../../../ko-utils';
import $api from '../../../../api';
import constructGeneralPerformance from './charts/generalPerformance';

class EventsPerformanceView {
    constructor(params) {
        this.isVisible = params.isVisible;
        this.isVisible.subscribe(val => {
            this.reinitIfVisible();
        });

        this.globalDateRange = params.globalDateRange;
        this.globalDateRange.subscribe(() => {
            this.reinitIfVisible();
        });

        this.generalChartState = ko.observable('loading');
        this.generalChartOptions = ko.observable({});

        this.reinitIfVisible();
    }

    get globalDateRangeUnwrapped() {
        return ko.unwrap(this.globalDateRange);
    }

    dispose() {
    }

    reinitIfVisible() {
        if (ko.unwrap(this.isVisible)) {
            this.reinit();
        }
    }

    reinit() {
        this.generalChartState('loading');
        this.generalChartOptions({});
        this.loadGeneralChart();
    }

    loadGeneralChart() {
        $api.events.getAggregation(
            {
                projectCode: auth.project.UniqueCode,
                dateFrom: this.globalDateRangeUnwrapped[0].toJSON(),
                dateTo: this.globalDateRangeUnwrapped[1].toJSON()
            },
            {},
            (resp) => {
                const strDates = Object.keys(resp.byDate);
                const allEvents = getAllEvents(resp.byDate);

                const series = [];

                for (const event of allEvents) {
                    const serieData = {
                        name: event,
                        data: []
                    };

                    series.push(serieData);

                    for (const date of strDates) {
                        const valsForDate = resp.byDate[date];

                        serieData.data.push(valsForDate[event] || 0);
                    }
                }
                console.log('S', series);
                if (series.length == 0) {
                    this.generalChartState('empty');
                } else {
                    this.generalChartState('loaded');
                }

                var xAxisCategories = strDates.map(i => new Date(i).toJSON());

                this.generalChartOptions(constructGeneralPerformance(xAxisCategories, series));
            }
        );
    }
}

function getAllEvents(data) {
    const keys = Object.keys(data);

    const events = [];
    for (const key of keys) {
        const item = data[key];
        Array.prototype.push.apply(events, Object.keys(item));
    }
    return events.filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => {
        return a.localeCompare(b);
    });
}

export default koComponent('events-performance-view', EventsPerformanceView);